import { NextApiHandler } from 'next'
import {
  MethodNotAllowedException,
  Method,
} from '@reward-platform/shared-api/exceptions/MethodNotAllowedException'
import { handleApiRouteError } from '../errors'

type NextApiHandlerMap = Partial<Record<Method, NextApiHandler>>

type MethodHandler = (apiRouteMap: NextApiHandlerMap) => NextApiHandler

export const handleMethods: MethodHandler = (handlers) => async (req, res) => {
  const method = req.method as Method | undefined
  const handler = method && handlers[method]
  if (handler) {
    handler(req, res)
  } else {
    const error = new MethodNotAllowedException(method)
    handleApiRouteError(error, req, res)
  }
}

export const handleMethod =
  (method: Method, handler: NextApiHandler): NextApiHandler =>
  async (req, res) => {
    if (req.method === method) {
      handler(req, res)
    } else {
      const error = new MethodNotAllowedException(method)
      handleApiRouteError(error, req, res)
    }
  }
